import { render, staticRenderFns } from "./AddTransaction.vue?vue&type=template&id=3809aeb9&scoped=true&"
import script from "./AddTransaction.vue?vue&type=script&lang=js&"
export * from "./AddTransaction.vue?vue&type=script&lang=js&"
import style0 from "./AddTransaction.vue?vue&type=style&index=0&id=3809aeb9&prod&lang=scss&scoped=true&"
import style1 from "./AddTransaction.vue?vue&type=style&index=1&id=3809aeb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809aeb9",
  null
  
)

export default component.exports